import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeReceiveSignal extends Shape {
    width = 200;
    height = 126;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = (height * 7) / 8 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 1.25) / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 10, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        const ctx = canv.ctx;

        let r = h / 30;
        if (w < 2 * r) r = w / 2;

        const nose = w * 0.22; // глубина стрелки
        ctx.beginPath();

        // Верхняя горизонталь
        ctx.moveTo(x, y);
        ctx.lineTo(x + w - r, y);
        // Правый верхний угол
        ctx.arcTo(x + w, y, x + w, y + r, r);
        // Правая вертикаль
        ctx.lineTo(x + w, y + h - r);
        // Правый нижний угол
        ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
        // Нижняя горизонталь
        ctx.lineTo(x, y + h);
        // Кончик стрелки
        ctx.arcTo(x + nose, y + h / 2, x, y + h, r);
        ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m23.2 5.00001-22.399951-.00001 5.887451 6.9736-5.887451 7.0264h22.399951z"
                stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
